// A Task is the single unified object for all goals and actionable items.
// Habits and Temptations are NOT tasks — they remain on the compass category object.
 
export const makeTask = ({
  text        = "",
  categoryId  = null,   // compass category id, or null = Uncategorized
  tier        = null,   // "shortterm" | "medterm" | "longterm" | null
  inTop10     = false,
  inTop3      = false,
  todayPhase  = null,   // "morning" | "afternoon" | "evening" | null
  todayTime   = null,
  deadline    = null,
  urgency     = null,   // "urgent" | "high" | "medium" | "low"
  commitment  = null,   // 1–10
  emotion     = null,   // anticipatory feeling
  emotionalStakes    = null,  // how will you feel after
  commitmentStatement = null, // why does this matter
  obstacle    = null,   // what might tempt you away
  enjoyNote   = null,   // how to make it more enjoyable
  microStep   = null,   // first step
  done        = false,
  parentGoalId = null,   // links task to a Goal document
  keyDateId   = null,   // links task to a Key Date (src/features/keydates/)
  dreamId     = null,   // links task to a dream (taskLinks.js)
  fearId      = null,   // links task to a fear (taskLinks.js)
  // ── Bubble Up fields ─────────────────────────────────────────────
  bubbleUrgency    = 1,      // 1–10; default lowest — user bubbles up from here
  bubbleImportance = 1,      // 1–10; default lowest
  bubbleSortOrder  = null,   // integer position, 1 = top; null = not yet ordered
  bubbleFocusToday = false,  // First 3 (parked on parked/shortlist-first3; the field stays on tasks)
  goalTaskOrder    = null,   // integer — sort order within parent goal
  bubbleFocusOrder = null,   // integer — order within First 3
  taskManualOrder  = null,   // integer — global manual sort order (drives all manual sort views)
} = {}) => ({
  text,
  categoryId,
  tier,
  inTop10,
  inTop3,
  todayPhase,
  todayTime,
  deadline,
  urgency,
  commitment,
  emotion,
  emotionalStakes,
  commitmentStatement,
  obstacle,
  enjoyNote,
  microStep,
  done,
  parentGoalId,
  keyDateId,
  dreamId,
  fearId,
  bubbleUrgency,
  bubbleImportance,
  bubbleSortOrder,
  bubbleFocusToday,
  goalTaskOrder,
  bubbleFocusOrder,
  taskManualOrder,
});
